// Utilidad para validar y formatear RUT chileno
// Formato SII: 12345678-9 (sin puntos)
// Formato humano: 12.345.678-9

const clean = (rut) => (rut || "").toString().replace(/[^0-9kK]/g, "").toUpperCase();

export function computeDv(numStr) {
  let s = 0, m = 2;
  let n = parseInt(numStr, 10);
  if (isNaN(n)) return "";
  while (n > 0) {
    s += (n % 10) * m;
    n = Math.floor(n / 10);
    m = m === 7 ? 2 : m + 1;
  }
  const r = 11 - (s % 11);
  if (r === 11) return "0";
  if (r === 10) return "K";
  return String(r);
}

export function validateRut(rut) {
  const raw = clean(rut);
  if (raw.length < 2) return false;
  const body = raw.slice(0, -1);
  const dv = raw.slice(-1);
  if (!/^\d+$/.test(body)) return false;
  return computeDv(body) === dv;
}

// Devuelve "12345678-9" o null si inválido
export function normalizeRut(rut) {
  const raw = clean(rut);
  if (raw.length < 2) return null;
  const body = raw.slice(0, -1);
  const dv = raw.slice(-1);
  if (!/^\d+$/.test(body)) return null;
  if (computeDv(body) !== dv) return null;
  return `${parseInt(body, 10)}-${dv}`;
}

// Enmascara el RUT para impresión: "15.123.456-1" -> "15XXXXXX-1"
// Mantiene los 2 primeros dígitos y el dígito verificador por seguridad del cliente.
export function maskRut(rut) {
  const raw = clean(rut);
  if (raw.length < 3) return raw;
  const body = raw.slice(0, -1).replace(/^0+/, "");
  const dv = raw.slice(-1);
  if (body.length <= 2) return `${body}-${dv}`;
  return `${body.slice(0, 2)}${"X".repeat(body.length - 2)}-${dv}`;
}

// Formatea con puntos: "12.345.678-9". Acepta rut parcial (mientras se escribe).
export function formatRut(rut) {
  const raw = clean(rut);
  if (raw.length < 2) return raw;
  const body = raw.slice(0, -1).replace(/^0+/, "");
  const dv = raw.slice(-1);
  const withDots = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${withDots}-${dv}`;
}
